import React from 'react';
import {HelpPopover} from './components/HelpPopover';
import {helpPopoverRef} from './constants';

export async function renderHelpPopover(root) {
    root.render(<HelpPopover ref={helpPopoverRef} />);

    return helpPopoverRef;
}
